import React, { useEffect, useState } from "react";
import renderInput from "helpers/FormGenerator";
import AdminLayout from "components/MainApp/layouts/DesktopLayout";
import locationIcon from "assets/images/icon-location-modal.png";
import selectIcon from "assets/images/icon-row-select.png";
import closeIcon from "assets/images/icon-close.png";
import tagSelectedIcon from "assets/images/icon-tags-selected.png";
import styles from "./LocationModal.module.scss";
import i18n from "i18n";
import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemAvatar, ListItemText } from "@material-ui/core";
import { ListItemButton } from "@mui/material";


export const LocationModal = ({
  openLocationForm,
  fields,
  handleClose,
  handleSelect,
  handleAdd,
  tagsSelected,
}) => {

  const [locationSelected, setLocationSelected] = useState();
  const [lastSeleted, setLastSelected] = useState(false);


  useEffect(() => {
    setLastSelected(false);
    if (fields && fields.length > 0) {
      let selectedText = "";
      fields.forEach((field) => {
        if (field.data.selectedOption) {
          if (fields[fields.length - 1] != field) {
            selectedText += field.data.selectedOption.label + " / ";
            setLastSelected(false)
          } else {
            setLastSelected(true)
          }
        } else {
          setLastSelected(false);
        }
      });
      setLocationSelected(selectedText.slice(0, -3));
    } else {
      setLocationSelected(undefined);
      setLastSelected(false);
    }
  }, [fields]);

  const content = (
    <div className={styles["location-modal-container"]}>
      <div className={styles["location-modal-content-wrapper"]}>
        <div className={styles["location-modal-content"]}>
          {fields &&
            fields.map((field) => {
              return renderInput(field, handleSelect, {}, styles["prep-order-field"]);
            })}
        </div>
        <div className={styles["load-movement-items-buttons-wrapper"]}>
          <div
            className={`${styles["load-movement-items-button"]}  ${styles["load-movement-items-add"]} `}
            onClick={handleAdd}
          >
            {" "}
            {i18n.t("add").toUpperCase()}{" "}
          </div>
        </div>
      </div>
    </div>
  );

  const isLocationSelected = (location) => {
    return fields[fields.length - 1].data.selectedOption === location;
  };

  return (

    <Dialog onClose={handleClose} open={openLocationForm} PaperProps={{ className: styles["location-modal-dialog"] }}>
      <div className={styles["location-moda-dialog-header"]}>
        <div className={styles["location-modal-dialog-header-title"]}>
          <div>
            <img src={locationIcon} alt="tag icon" className={styles["location-modal-dialog-header-icon"]} />
          </div>
          <div className={styles["location-modal-dialog-header-text"]}>
            <div className={styles["location-modal-dialog-header-text-title"]}>
              {i18n.t("locations")}
            </div>
            <div className={styles["location-modal-dialog-header-text-subtitle"]}>
              {i18n.t("select.location")}
            </div>
          </div>
        </div>
        <div>
          <img src={closeIcon} alt="close icon" onClick={handleClose} className={styles["close-icon"]} />
        </div>
      </div>
      <DialogContent>
        <List sx={{ pt: 0 }}>
          <ListItem disablePadding className={styles["location-modal-list-main"]}>
            <div className={styles["location-modal-tags-selected"]}>
              <div>
                <img src={tagSelectedIcon} alt="tag selected icon" className={styles["tags-selected-icon"]}/>
              </div>
              <div>
                {tagsSelected} {i18n.t("selected.tags")}
              </div>
            </div>

          </ListItem>
          {locationSelected &&
            <ListItem disablePadding>
              <ListItemButton onClick={() => handleSelect(fields[fields.length - 2].data.selectedOption, fields[fields.length - 2].data.name)}>
                <img src={selectIcon} style={{ height: "13px", transform: "rotate(180deg)" }} />
                <ListItemText primary={locationSelected} style={{ marginLeft: "15px" }} />
              </ListItemButton>
            </ListItem>
          }
          {fields.length > 0 && fields[fields.length - 1].data.options.map((location) => (
            <ListItem disablePadding key={location.id} className={styles["location-modal-list-item"] + (lastSeleted && isLocationSelected(location) ? " " + styles["last-selected"] : "")}>
              <ListItemButton onClick={() => handleSelect(location, fields[fields.length - 1].data.name)} className={styles["location-modal-list-item-button"]
              }>
                <ListItemText className={styles["location-modal-list-item-text"]} primary={location.label} />
                {!(lastSeleted && isLocationSelected(location)) &&
                  <img src={selectIcon} style={{ height: "13px" }} />
                }
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions className={styles["location-modal-dialog-actions"]}>
        <Button variant="text" onClick={handleClose} className={styles["cancel-button"]}   >{i18n.t("cancel")}</Button>
        <Button variant="contained" onClick={handleAdd} className={styles["save-button"]} >{i18n.t("save")}</Button>
      </DialogActions>
    </Dialog>

  );
};

export default LocationModal;
